import React, { useEffect, useState } from 'react';
import './CategoryList.scss';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Link, Fab, Dialog, Drawer, makeStyles } from '@material-ui/core';
import { http, FxInput, FxSelect, useNavigationService, AlertService, general } from '../../fx-core';
import { NoRecords } from '../../NoRecords/NoRecords';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import dummyImage from "../../../assets/images/dummy.png";
import CategoryForm from '../CategoryForm/CategoryForm';
import { download, generateCsv, mkConfig } from 'export-to-csv';
const styles = makeStyles((theme) => ({
    drawerWidth: {
        [theme.breakpoints.down(599)]: {
            width: '90%'
        },
        [theme.breakpoints.up(600)]: {
            width: '70%'
        },
        [theme.breakpoints.up(1025)]: {
            width: '40%'
        }
    }
}));

const CategoryList = () => {
    const { routeData, back, goTo } = useNavigationService();
    const classes = styles();

    let defaultFilter: any = {
        name: ""
    };
    const [filters, setFilters] = useState(defaultFilter);
    const [categories, setCategories] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [selectedId, setSelectedId] = useState(0);
    const [categoryFormOpen, setCategoryFormOpen] = useState(false);

    const handleInputChange = (item) => {
        handleFilterChange({ [item.name]: item.value });
        let filterObj = {
            name: filters.name
        }
        if (item.name == "name") {
            filterObj.name = item.value;
        }
        getCategories(filterObj);
    };

    const handleFilterChange = (data) => {
        setFilters(prevState => {
            return { ...prevState, ...data }
        });
    };

    const getCategories = (data: any) => {
        let inputData = {
            communityId: routeData.communityId,
            categoryName: data.name
        };
        let apiOptions: any = {
            url: `category/query`,
            data: inputData
        };
        http.post(apiOptions).then(res => {
            getCategoriesCallBack(res);
        });
    };

    // const getCategoriesCallBack = (res) => {
    //     let result = res.data;
    //     for (let item of result) {
    //         item.imageUrl = general.getImageUrl(item.imagePath);
    //     }
    //     setCategories(result);
    // }
    const getCategoriesCallBack = (res) => {
    const result = res.data || [];

    const mapped = result.map((item: any) => {
        const stall = item.Stall || {};
        const services = Array.isArray(item.Services) ? item.Services : [];

        // build serviceName string (join multiple services with ", ")
        const serviceNames = services
            .map((s: any) => s.ServiceName || s.serviceName || "")
            .filter((n: string) => n && n.trim().length > 0);
        const serviceName = serviceNames.length === 0 ? "" : serviceNames.join(", ");

        // image path / url
        const imagePath = stall.ImagePath || stall.imagePath || "";
        const imageUrl = imagePath ? general.getImageUrl(imagePath) : null;

        return {
            // fields your UI expects
            categoryName: stall.StallName || stall.Name || "", 
            serviceName: serviceName,
            isActive: stall.IsActive === undefined ? false : stall.IsActive,
            imagePath: imagePath,
            imageUrl: imageUrl,
            id: stall.Id || stall.id || 0,

            // keep originals if needed later
            _rawStall: stall,
            _rawServices: services
        };
    });

    setCategories(mapped);
}

    const addOrEditCategory = (id) => {
        setCategoryFormOpen(true);
        setSelectedId(id);
    }

    const handleCategoryFormClose = () => {
        setCategoryFormOpen(false);
        setSelectedId(0);
        getCategories(filters);
    }

    const confirmDelete = (item) => {
        setConfirmOpen(true);
        setMessage("Are you sure to delete " + item.categoryName + "?");
        setSelectedId(item.id);
    }
    

    const handleDialogClose = () => {
        setConfirmOpen(false);
        setSelectedId(0);
        setMessage("");
    };

    const onConfirmCallback = () => {
        const id = selectedId;
        deleteCategory(id);
        handleDialogClose()
    };

    const deleteCategory = (id) => {
        let apiOptions: any = {
            url: `category/${id}`
        };
        http.delete(apiOptions).then(response => {
            AlertService.showMsg({ message: "Deleted successfully" });
            getCategories(filters);
        })
    };

    const navToBack = () => {
        back();
    };

    const navToDashboard = () => {
        goTo(1);
    };

    useEffect(() => {
        getCategories(filters);
    }, []);

    const csvConfig = mkConfig({
  filename: 'category_list',
  useKeysAsHeaders: true,
  quoteStrings: true,
});

const csvData = categories.map((categotylist: any) => ({
  ItemName: categotylist.categoryName || "",
  Category: categotylist.serviceName || "",
  Action: categotylist.isActive ? 'Active' : 'Inactive',
}));

    return (
        <div className='category-list-ui pt-5'>
            <div className="title-font custom-head pl-4 pt-5">
                <Breadcrumbs aria-label="breadcrumb">
                    <Link color="primary" className="custom-link pointer breadcrumbs-style" onClick={navToDashboard}>
                        <b>{routeData.communityName}</b>
                    </Link>
                    {/* <Typography color="primary" className="breadcrumbs-style">
                        <Link color="primary" className="custom-link pointer breadcrumbs-style" onClick={navToBack}>
                            <b>Items</b>
                        </Link>
                    </Typography> */}
                    <Typography color="primary" className="breadcrumbs-style">Categories</Typography>
                </Breadcrumbs>
            </div>
            <div className='content-container'>
                <div className="content">
                    <div className='row my-4 mx-2'>
                        <div className="col-3">
                            <FxInput
                                name="name"
                                value={filters.name}
                                variant="outlined"
                                label="Search"
                                fullWidth
                                size="small"
                                onValueChange={handleInputChange}
                            />
                        </div>
                        <div className="col-3">
                        </div>
                        <div className='col-3'>
                        </div>
                        {/* <div className='col-3'>
                            <span className='d-flex justify-content-end pr-3'>
                                <Fab
                                    variant="extended"
                                    size="medium"
                                    color="primary"
                                    onClick={() => addOrEditCategory(0)}
                                >
                                    <i className="fas fa-plus pr-2"></i>
                                    Add
                                </Fab>
                            </span>
                        </div> */}
                    </div>
                        <div className='row my-4 mx-4 pt-2'>
                            <button
                            className="btn btn-primary mb-3"
                            onClick={() => {
                                const csv = generateCsv(csvConfig)(csvData);
                                download(csvConfig)(csv);
                            }}
                            >
                            Download All Items as CSV
                            </button>
                        </div>
                    <div className='row my-4 mx-4 pt-2'>
                        <TableContainer component={Paper}>
                            <Table className="table-striped" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Stall Name</TableCell>
                                        <TableCell>Category</TableCell>
                                        
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        categories.length == 0 &&
                                        <TableCell colSpan={4}>
                                            <NoRecords />
                                        </TableCell>
                                    }
                                    {
                                        categories.length > 0 && categories.map((row: any, i) => (
                                            <TableRow key={i}>
                                                {/* <TableCell>
                                                    {!row.imageUrl && <img src={dummyImage} alt="Item" width="50" height="50"></img>}
                                                    {row.imageUrl && <img src={row.imageUrl} alt="Item" width="50" height="50"></img>}
                                                </TableCell> */}
                                                <TableCell>
                                                    {row.categoryName}
                                                </TableCell>
                                                <TableCell>
                                                    {row.serviceName}
                                                </TableCell>
                                                <TableCell>
                                                    {row.isActive ? 'Active' : 'Inactive'}
                                                </TableCell>
                                                {/* <TableCell>
                                                    <div>
                                                        <span className='pointer'><i className="fas fa-pencil-alt font-13" onClick={() => addOrEditCategory(row.id)}></i></span>
                                                        <span className='ml-3 pointer'><i className="fas fa-trash-alt font-13" onClick={() => confirmDelete(row)}></i></span>
                                                    </div>
                                                </TableCell> */}
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
            <Dialog
                open={confirmOpen}
                maxWidth="sm"
                fullWidth
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <ConfirmDialog message={message} handleDialogClose={handleDialogClose} onConfirmCallback={onConfirmCallback} />
            </Dialog>
            <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={categoryFormOpen} onClose={handleCategoryFormClose}>
                <CategoryForm categoryId={selectedId} communityId={routeData.communityId} handleCategoryFormClose={handleCategoryFormClose} />
            </Drawer>
        </div>
    );
}
export default CategoryList;